<template>
  <div :class="last ? '' : 'border-b border-surface-100'">
    <div
      v-for="(option, i) in options"
      :key="String(option.value)"
      class="flex items-start gap-3 py-2.5"
      :class="[
        i < options.length - 1 ? 'border-b border-dashed border-surface-100' : '',
        disabled ? 'pointer-events-none opacity-60' : 'cursor-pointer'
      ]"
      @click="$emit('update:modelValue', option.value)"
    >
      <span
        class="w-[19px] h-[19px] rounded-full flex-none mt-0.5 box-border bg-white transition-all"
        :class="modelValue === option.value ? 'border-[6px] border-primary' : 'border-2 border-surface-300'"
      />
      <span class="flex-1 min-w-0">
        <span
          class="block text-sm"
          :class="modelValue === option.value ? 'font-semibold text-surface-900' : 'font-medium text-surface-700'"
        >{{ option.label }}</span>
        <span v-if="option.desc" class="block text-xs text-surface-500 mt-0.5 leading-snug text-pretty">{{ option.desc }}</span>
      </span>
    </div>
  </div>
</template>

<script setup lang="ts" generic="T extends string | number">
defineProps<{
  options: Array<{ value: T; label: string; desc?: string }>;
  modelValue?: T;
  last?: boolean;
  disabled?: boolean;
}>();
defineEmits<{ 'update:modelValue': [value: T] }>();
</script>
